import { useNavigate, Link } from "react-router-dom";
import "../styles/style.css";

function Home() {
  const navigate = useNavigate();
  return (
    <>
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <span className="badge">🎓 Registration Open 2026</span>
          <h1>
            Learn <span>Future</span>
            <br />
            Skills Today
          </h1>
          <p>
            Master in-demand technologies with industry-led internships and
            real-world projects that get you hired.
          </p>
          <button className="apply-btn" onClick={() => navigate("/courses")}>
            Explore Courses →
          </button>
          <div className="hero-stats">
            <div className="stat-item">
              <b>500+</b> Students Enrolled
            </div>
            <div className="stat-item">
              <b>10+</b> Industry Partners
            </div>
            <div className="stat-item">
              <b>8</b> Tech Courses
            </div>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="feature-item">
          <span className="icon">🚀</span>
          <h4>Fast Track</h4>
          <p>
            Practical, job-focused learning designed to get you industry-ready
            in weeks, not years.
          </p>
        </div>
        <div className="feature-item">
          <span className="icon">💼</span>
          <h4>Internships</h4>
          <p>
            Top performers get guaranteed internship slots with our network of
            tech partners.
          </p>
        </div>
        <div className="feature-item">
          <span className="icon">🎓</span>
          <h4>Certifications</h4>
          <p>
            Industry-verified certificates to boost your LinkedIn and make
            recruiters notice you.
          </p>
        </div>
      </section>

      <section className="courses-preview">
        <div className="section-title">
          <span className="section-label">Trending</span>
          <h2>
            Top Rated <span>Courses</span>
          </h2>
          <p>
            Handpicked by industry experts to match what employers actually need
            right now.
          </p>
        </div>
        <div className="modern-grid">
          <div className="modern-card">
            <div className="card-img-container">
              <div className="card-tag">🔥 Hot</div>
              <img
                src="https://images.unsplash.com/photo-1627398242454-45a1465c2479?w=400"
                alt="Web Dev"
              />
            </div>
            <div className="card-info">
              <h3>Full Stack Development</h3>
              <p>
                Build real-world apps with React, Node.js, and MongoDB from
                scratch.
              </p>
              <div className="card-footer">
                <span>⭐ 4.9 (150+ reviews)</span>
                <Link to="/courses" className="view-link">
                  View Details →
                </Link>
              </div>
            </div>
          </div>
          <div className="modern-card">
            <div className="card-img-container">
              <div className="card-tag">Design</div>
              <img
                src="https://images.unsplash.com/photo-1561070791-2526d30994b5?w=400"
                alt="UI/UX"
              />
            </div>
            <div className="card-info">
              <h3>UI/UX Masterclass</h3>
              <p>
                Learn Figma, user research, and prototyping — design like a pro.
              </p>
              <div className="card-footer">
                <span>⭐ 4.8 (90+ reviews)</span>
                <Link to="/courses" className="view-link">
                  View Details →
                </Link>
              </div>
            </div>
          </div>
          <div className="modern-card">
            <div className="card-img-container">
              <div className="card-tag">New</div>
              <img
                src="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=400"
                alt="Cyber"
              />
            </div>
            <div className="card-info">
              <h3>Cyber Security</h3>
              <p>
                Ethical hacking, network defense, and security auditing — all in
                one track.
              </p>
              <div className="card-footer">
                <span>⭐ 4.7 (60+ reviews)</span>
                <Link to="/courses" className="view-link">
                  View Details →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-banner">
        <h2>Ready to transform your career?</h2>
        <p>
          Start learning today and get ahead of the competition with TechSphere.
        </p>
        <button className="join-btn" onClick={() => navigate("/apply")}>
          Apply for Internship →
        </button>
      </section>
    </>
  );
}
export default Home;
